import { IJSLComponent, IJSLVNode, refresh, JSLRender } from "jsl-render";
import { FundOrtModel } from "../../../ajax/types/FundOrtModel";
import { StackPanelComponent } from "../layout/StackPanelComponent";
import { GemeindeModel } from "../../../ajax/types/GemeindeModel";
import { SelectTaxonComponent, ITaxonInfo } from "../SelectTaxonComponent";
import { FormFieldComponent, numeric, date, EventHandler } from "jsl-ui";
import { DropDownComponent } from "jsl-ui/lib/components/drop-down/DropDownComponent";
import { PublicController } from "../../../ajax/PublicController";
import { ExpertController } from "../../../ajax/ExpertController";
import { FundModel } from "../../../ajax/types/FundModel";
import { FundDetailsDTO } from "../../../ajax/types/FundDetailsDTO";
import { MapComponent } from "../map/MapComponent";
import { LandModel } from "../../../ajax/types/LandModel";

export class EditFundComponent implements IJSLComponent {

    public fundOrtId?: number;
    private landData: LandModel[];
    private landValue: string;
    private refGemeinden: GemeindeModel[];
    private calculatedGemeinde: GemeindeModel;

    private selectTaxon: SelectTaxonComponent;
    private fundDatum: FormFieldComponent;
    private sammler: FormFieldComponent;
    private oekosystem: DropDownComponent;
    private oekosystemKommentar: FormFieldComponent;
    private bestimmer: FormFieldComponent;
    private fundOrtName: FormFieldComponent;
    private fundOrtBeschreibung: FormFieldComponent;

    private bundesland: DropDownComponent;
    private bezirk: DropDownComponent;
    private gemeinde: DropDownComponent;

    private latitude: FormFieldComponent;
    private longitude: FormFieldComponent;
    private mtbq: FormFieldComponent;

    private laender: DropDownComponent;

    private meerHoeheVon: FormFieldComponent;
    private meerHoeheBis: FormFieldComponent;

    private herbariumOef: DropDownComponent;
    private herbarOefNr: FormFieldComponent;
    private herbariumPriv: DropDownComponent;    
    private herbarPrivNr: FormFieldComponent;
    private herbarPrivKommentar: FormFieldComponent;

    private datenquelle: DropDownComponent;
    private substrat: DropDownComponent;
    private substratKommentar: FormFieldComponent;
    private DokuDiasFotos: FormFieldComponent;

    private existingFundOrt?: FundOrtModel;

    private mapComponent: MapComponent;

    private longLatEntered = EventHandler.Create(null);

    public constructor(private fund?: FundDetailsDTO) {
        if (fund != null) {
            this.selectTaxon = new SelectTaxonComponent({ id: fund.taxaId, name: fund.name });
        } else {
            this.selectTaxon = new SelectTaxonComponent();
        }
        this.fundDatum = new FormFieldComponent({ label: "Fund Datum", class: "common-input mt-20", type: "date" });
        this.sammler = new FormFieldComponent({ label: "Sammler", maxLength: 500, class: "common-input mt-20" });
        this.bestimmer = new FormFieldComponent({ label: "Bestimmer", maxLength: 500, class: "common-input mt-20" });
        this.fundOrtName = new FormFieldComponent({ label: "Fundort Name", class: "common-input mt-20" });
        this.fundOrtBeschreibung = new FormFieldComponent({ label: "Fundort Beschreibung", class: "common-input mt-20" });
        const requests = [];
        requests.push(PublicController.GetGemeinden().then((gemeinden) => {
            this.refGemeinden = gemeinden;
            const g = gemeinden._select((el) => el.bundesland)._distinct();
            this.bundesland = new DropDownComponent({
                clearable: true,
                defaultSelected: false, data: g.map((x) => ({ value: x, text: x })),
                onSelect: ((val) => { this.fillBezirke(val as string); })
            });
            refresh();
        }));
        requests.push(PublicController.GetOekosysteme().then((d) => {
            this.oekosystem = new DropDownComponent({
                clearable: true,
                pagination: 100,
                defaultSelected: false,
                data: d.map((x) => ({ value: x.id, text: x.id })),
                placeholder: "Ökosystem"
            });
            refresh();
        }));
        requests.push(PublicController.GetHerbarien().then((d) => {
            // this.refHerbar = d;
            this.herbariumOef = new DropDownComponent({
                defaultSelected: false,
                clearable: true,
                data: d.map((x) => ({ value: x.shortName, text: x.name })),
                placeholder: "Herbarium (öffentlich)",
                class: "mt-20",
                onChange: new EventHandler(() => {
                    refresh();
                })
            });
            refresh();
        }));
        requests.push(PublicController.GetHerbarienPrivat().then((d) => {
            // this.refHerbarPriv = d;
            this.herbariumPriv = new DropDownComponent({
                defaultSelected: false,
                clearable: true,
                pagination: 100,
                data: d.map((x) => ({ value: x.id, text: x.name })),
                placeholder: "Herbarium (privat)",
                class: "mt-20",
                onChange: new EventHandler(() => {
                    refresh();
                })
            });
            refresh();
        }));
        requests.push(PublicController.GetSubstrate().then((d) => {
            this.substrat = new DropDownComponent({
                defaultSelected: false,
                pagination: 100,
                clearable: true,
                data: d.map((x) => ({ value: x.id, text: x.code })),
                placeholder: "Substrat",
                class: "mt-20",
                onChange: new EventHandler(() => {
                    refresh();
                })
            });
            refresh();
        }));
        const renderDD = (option) => {
            return "<div><div>" + this.escape(option.data.titel) + "</div>" +
                "<div style='font-size:0.9em;border-bottom:1px solid #d0d0d0;'><i>" + this.escape(option.data.autor) + " (" + option.data.jahr + ")</i></div></div>";
        };
        requests.push(PublicController.GetDatenquellen().then((d) => {
            // this.refDatenquelle = d;
            this.datenquelle = new DropDownComponent({
                defaultSelected: false,
                clearable: true,
                pagination: 100,
                data: d.map((x) => ({ value: x.id, text: (x.titel ?? "") + " " + (x.iSBN ?? "") + " " + (x.autor ?? ""), data: x })),
                placeholder: "Datenquelle",
                class: "mt-20",
                renderOption: renderDD,
                renderSelection: renderDD
            });
            refresh();
        }));
        requests.push(PublicController.GetAllLaender().then((laender) => {
            this.landData = laender;
            this.laender = new DropDownComponent({
                defaultSelected: false,
                multiple: false,
                clearable: true,
                pagination: 80,
                class: "mt-20",
                value: "A",
                placeholder: "Länder",
                data: this.landData.map((l) => ({ value: l.id, text: l.id + " - " + l.name, data: l})),
                onChange: new EventHandler(() => {
                    refresh();
                })
            });
            refresh();
        }));
        this.latitude = new FormFieldComponent({
            label: "Breitengrad", class: "common-input mt-20 mr-10", type: "number",
            numberOptions: {
                format: "0.#####", onChange: () => {
                    this.updateGemeinde();
                    this.updateMTBQ();
                    this.longLatEntered.notify();
                }
            }
        });
        this.longitude = new FormFieldComponent({
            label: "Längengrad", class: "common-input mt-20 ml-10", type: "number",
            numberOptions: {
                format: "0.#####", onChange: () => {
                    this.updateGemeinde();
                    this.updateMTBQ();
                    this.longLatEntered.notify();
                }
            }
        });
        this.mtbq = new FormFieldComponent({
            label: "MTBQ", class: "common-input mt-20 ml-10", type: "number",
            numberOptions: { onChange: () => { this.updateLatLon(); } }
        });
        this.meerHoeheVon = new FormFieldComponent({ label: "Meereshöhe [m] von", class: "common-input mt-10 mr-10", type: "number" });
        this.meerHoeheBis = new FormFieldComponent({ label: "Meereshöhe [m] bis", class: "common-input mt-10 ml-10", type: "number" });
        this.herbarOefNr = new FormFieldComponent({ label: "Herbar Nummer (öffentlich)", maxLength: 100, class: "common-input mt-10 ml-10" });
        this.herbarPrivNr = new FormFieldComponent({ label: "Herbar Nummer (privat)", maxLength: 100, class: "common-input mt-10 ml-10" });
        this.herbarPrivKommentar = new FormFieldComponent({label: "Herbar (privat) Kommentar", type: "text", class: "common-input mt-10 ml-10"})
        this.substratKommentar = new FormFieldComponent({ label: "Substrat Kommentar", class: "common-input mt-10 ml-10" });
        this.DokuDiasFotos = new FormFieldComponent({label: "Doku Dias Fotos", class: "common-input mt-10 ml-10"});
        this.oekosystemKommentar = new FormFieldComponent({ label: "Ökosystem Kommentar", class: "common-input mt-10 mr-10", type: "text" });
        this.longLatEntered.subscribe(() => {
            if (this.latitude.getValue() && this.longitude.getValue()) {
                PublicController.GetElevationToLocation({lat: numeric.parse(this.latitude.getValue()), lng: numeric.parse(this.longitude.getValue())}).then((result) => {                    
                    if (Number(result.elevation) === -9999) {
                        alert("Meereshöhe an Koordinaten konnten nicht gefunden werden");
                    } else {
                        this.meerHoeheVon.setValue(Math.round(Number(result.elevation) - (Number(result.resolution) / 2)).toString());
                        this.meerHoeheBis.setValue(Math.round(Number(result.elevation) + (Number(result.resolution) / 2)).toString());
                        refresh();
                    }
                });
            }
        });
        if (fund != null) {
            Promise.all(requests).then(() => {
                JSLRender.lastCreatedRenderer.render();
                this.fundDatum.setValue(date.format(fund.fundDatum));
                this.sammler.setValue(fund.sammler);
                this.bestimmer.setValue(fund.bestimmer);
                this.fundOrtName.setValue(fund.fundortName);
                this.fundOrtBeschreibung.setValue(fund.fundortBeschreibung);
                this.mtbq.setValue(fund.mtbq);
                this.latitude.setValue(numeric.format(fund.latitude, "0.#####"));
                this.longitude.setValue(numeric.format(fund.longitude, "0.#####"));
                this.meerHoeheVon.setValue(numeric.format(fund.meerHoeheVon));
                this.meerHoeheBis.setValue(numeric.format(fund.meerHoeheBis));
                this.DokuDiasFotos.setValue(fund.dokuDiasFotos);
                if (fund.herbarPrivId != null && this.herbariumPriv.getRef() != null) {
                    this.herbariumPriv.getRef().setValue(fund.herbarPrivId.toString());
                }
                if (fund.herbarOefId != null && this.herbariumOef.getRef() != null) {
                    this.herbariumOef.getRef().setValue(fund.herbarOefId);
                }
                if (fund.datenquelleId != null && this.datenquelle.getRef() != null) {
                    this.datenquelle.getRef().setValue(fund.datenquelleId.toString());
                }
                if (fund.staat != null && this.laender.getRef() != null) {
                    this.laender.getRef().setValue(fund.staat);
                }
                if (fund.substratId != null && this.substrat.getRef() != null) {
                    this.substrat.getRef().setValue(fund.substratId.toString());
                }
                if (fund.oekosystemCode != null && this.oekosystem.getRef() != null) {
                    this.oekosystem.getRef().setValue(fund.oekosystemCode);
                }
                this.herbarOefNr.setValue(fund.herbarOefNr);
                this.herbarPrivNr.setValue(fund.herbarPrivNr);
                this.herbarPrivKommentar.setValue(fund.herbarPrivKommentar);
                if (this.bundesland.getRef() != null) {
                    this.bundesland.getRef().setValue(fund.bundesland);
                    this.fillBezirke(this.fund.bundesland);
                    if (fund.bezirk != null) {
                        this.bezirk.getRef().setValue(fund.bezirk);
                        this.fillGemeinden(fund.bundesland, fund.bezirk);
                        if (fund.gemeinde != null) {
                            this.gemeinde.getRef().setValue(fund.gemeinde);
                        }
                    }
                }
                refresh();
            });
            // TODO: Bezirk und Gemeinden
            // if (fund.bezirk != null) {
            //     this.bezirk.getRef().setValue(fund.bezirk);
            // }
        }
    }

    public render(): IJSLVNode {

        return <div>
            <h3>Fund Informationen</h3>
            {this.selectTaxon}
            {this.sammler}
            {this.bestimmer}
            <div class="mt-20">
                <label for="up-grad">Bestimmungs Qualität: </label>
                <select id="up-grad">
                    <option value="sicher" selected={this.fund?.bestimmungsQualitaet === "sicher" ? "selected" : undefined}>sicher</option>
                    <option value="unsicher" selected={this.fund?.bestimmungsQualitaet === "unsicher" ? "selected" : undefined}>unsicher</option>
                    <option value="agg." selected={this.fund?.bestimmungsQualitaet === "agg." ? "selected" : undefined}>agg.</option>
                    <option value="cf." selected={this.fund?.bestimmungsQualitaet === "cf." ? "selected" : undefined}>cf.</option>
                    <option value="aff." selected={this.fund?.bestimmungsQualitaet === "aff." ? "selected" : undefined}>aff.</option>
                    
                    <option value="s. str." selected={this.fund?.bestimmungsQualitaet === "s. str." ? "selected" : undefined}>s. str.</option>
                    
                </select>
            </div>
            {this.fundDatum}
            {this.oekosystem}
            {this.oekosystemKommentar}
            {this.substrat}
            {this.substratKommentar}
            <div>{this.herbariumOef}</div>
            <div>{(this.herbariumOef?.getRef()?.getValue() || this.fund?.herbarOefNr) ?
                this.herbarOefNr : null}</div>
            <div>{this.herbariumPriv}</div>
            <div>{(this.herbariumPriv?.getRef()?.getValue() || this.fund?.herbarPrivNr) ?
                <div>{this.herbarPrivNr}{this.herbarPrivKommentar}</div> : null}</div>
            {this.datenquelle}
            {this.DokuDiasFotos}
            <textarea class="common-textarea form-control mt-20" id="up-fund-kommentar"
                placeholder="Kommentar / Bemerkung">{this.fund?.kommentar}</textarea>

            <h3>Fundort</h3>
            {/* {this.myUploads.count() > 0 ?
                <div>
                    <div style="float:right"><button class="genric-btn default-border"
                        click={() => { this.myUploads.getData().then((d) => this.setFundOrt(d[0].fundOrtId)); }}>
                        Fundort meines letzten Fundes verwenden</button></div>
                    <div style="clear:both"></div>
                </div> : null} */}
            {this.existingFundOrt != null ?
                <div>
                    <p>Fundort Name: {this.existingFundOrt?.fundortName || "-"}</p>
                    <p>Fundort Beschreibung: {this.existingFundOrt?.fundortBeschreibung || "-"}</p>
                </div> :
                <div>
                    {this.fundOrtName}
                    {this.fundOrtBeschreibung}
                    <button class="genric-btn default-border" click={() => {
                        this.mapComponent = this.mapComponent != null ? null : new MapComponent([], {
                            showMarkerOnClick: true,
                            onClick: new EventHandler((arg) => {
                                this.latitude.setValue(numeric.format(arg.lat, "0.00000"));
                                this.longitude.setValue(numeric.format(arg.lon, "0.00000"));
                                PublicController.GetElevationToLocation({lat: arg.lat, lng: arg.lon}).then((result) => {                    
                                    if (Number(result.elevation) === -9999) {
                                        alert("Meereshöhe konnte bei Koordinaten nicht bestimmt werden");
                                    } else {
                                        this.meerHoeheVon.setValue(Math.round(Number(result.elevation) - (Number(result.resolution) / 2)).toString());
                                        this.meerHoeheBis.setValue(Math.round(Number(result.elevation) + (Number(result.resolution) / 2)).toString());
                                        refresh();
                                    }
                                });
                                refresh();
                                this.updateGemeinde();
                                this.updateMTBQ();
                            })
                        });
                    }}>{this.mapComponent != null ? "Karte ausblenden" : "aus Karte auswählen"}</button>
                    <div>{this.mapComponent}</div>
                    {new StackPanelComponent([this.latitude, this.longitude, this.mtbq])}
                        <div>{this.laender}</div>
                    {this.laender?.getRef()?.getValue()?.toString() == "A" ?
                    <div>
                        {this.calculatedGemeinde == null ?
                            <div>
                                {new StackPanelComponent([
                                    { tag: "label", content: "Bundesland:" },
                                    this.bundesland
                                ], { sizes: ["8rem"] })}
                                {new StackPanelComponent([
                                    { tag: "label", content: "Bezirk:" },
                                    this.bezirk
                                ], { sizes: ["8rem"] })}
                                {new StackPanelComponent([
                                    { tag: "label", content: "Gemeinde:" },
                                    this.gemeinde
                                ], { sizes: ["8rem"] })}
                            </div> :
                            <div>{this.calculatedGemeinde.bundesland} - {this.calculatedGemeinde.bezirk} - {this.calculatedGemeinde.gemeinde}</div>}
                    </div> : <div></div>}
                    {new StackPanelComponent([this.meerHoeheVon, this.meerHoeheBis])}
                </div>
            }
            {/*
BodenTyp
RegionNaturraum
RegionGebirgsraum
KlimaTyp */}
        </div>;
    }

    public setFundOrt(id?: number) {
        this.fundOrtId = id;
        this.selectTaxon = new SelectTaxonComponent();
        if (this.fundOrtId != null) {
            PublicController.GetFundOrt({ id }).then((ort) => {
                this.existingFundOrt = ort;
                refresh();
            });
        } else {
            this.existingFundOrt = null;
            refresh();
        }
    }

    public getTaxon(): ITaxonInfo {
        return this.selectTaxon.getSelected();
    }

    public getData(fund: FundModel, ort: FundOrtModel) {
        fund.taxaId = this.selectTaxon.getSelected().id;
        fund.bestimmer = this.bestimmer.getValue();
        fund.sammler = this.sammler.getValue();
        fund.kommentar = (document.getElementById("up-fund-kommentar") as HTMLTextAreaElement).value;
        fund.bestimmungsQualitaet = (document.getElementById("up-grad") as HTMLSelectElement).value;
        fund.fundDatum = date.parse(this.fundDatum.getValue());
        fund.oekosystemCode = this.oekosystem.getRef()?.getValue() as string;
        fund.herbarOefId = this.herbariumOef.getRef()?.getValue() as string;
        fund.herbarPrivId = parseInt(this.herbariumPriv.getRef()?.getValue() as string, 10);
        fund.datenquelleId = parseInt(this.datenquelle.getRef()?.getValue() as string, 10);
        fund.herbarOefNr = this.herbarOefNr.getValue();
        fund.herbarPrivNr = this.herbarPrivNr.getValue();
        fund.substratId = parseInt(this.substrat.getRef()?.getValue() as string, 10);
        fund.substratKommentar = this.substratKommentar.getValue();
        fund.oekosystemKommentar = this.oekosystemKommentar.getValue();
        fund.dokuDiasFotos = this.DokuDiasFotos.getValue();

        if (ort != null) {
            ort.fundortBeschreibung = this.fundOrtBeschreibung.getValue();
            ort.fundortName = this.fundOrtName.getValue();
            ort.staat = this.laender.getRef().getValue().toString();
            ort.bundesland = this.calculatedGemeinde?.bundesland ?? this.bundesland?.getRef()?.getValue() as string;
            ort.bezirk = this.calculatedGemeinde?.bezirk ?? this.bezirk?.getRef()?.getValue() as string;
            ort.gemeinde = this.calculatedGemeinde?.gemeinde ?? this.gemeinde?.getRef()?.getValue() as string;
            ort.latitude = numeric.parse(this.latitude.getValue());
            ort.longitude = numeric.parse(this.longitude.getValue());
            ort.meerHoeheVon = numeric.parse(this.meerHoeheVon.getValue());
            ort.meerHoeheBis = numeric.parse(this.meerHoeheBis.getValue());
            ort.mtbq = this.mtbq.getValue();
        } else if (this.fundOrtId != null) {
            fund.fundOrtId = this.fundOrtId;
        }
    }

    private updateGemeinde() {
        const latitude = numeric.parse(this.latitude.getValue());
        const longitude = numeric.parse(this.longitude.getValue());
        if (latitude && longitude) {
            ExpertController.getGemeinde({ lat: latitude, lon: longitude }).then((g) => {
                if (g.length !== 1) {
                    this.calculatedGemeinde = null;
                } else {
                    const foundEntries = this.refGemeinden.filter((x) => x.gemeinde.toLowerCase() === g[0].toLowerCase());
                    if (foundEntries.length === 1) {
                        this.calculatedGemeinde = foundEntries[0];
                    } else {
                        this.calculatedGemeinde = null;
                    }
                }
                refresh();
            });
        }
    }

    private escape(txt: string): string {
        return txt ?? "-";
    }

    private updateMTBQ() {
        const latitude = numeric.parse(this.latitude.getValue());
        const longitude = numeric.parse(this.longitude.getValue());
        if (latitude && longitude) {
            ExpertController.LatLonToMtbq({ lat: latitude, lon: longitude }).then((g) => {
                this.mtbq.setValue(g);
                refresh();
            });
        }
    }

    private updateLatLon() {
        const mtbq = this.mtbq.getValue();
        if (mtbq) {
            ExpertController.MtbqToLatLon({ mtbq }).then((g) => {
                this.latitude.setValue(numeric.format(g.lat, "0.00000"));
                this.longitude.setValue(numeric.format(g.lon, "0.00000"));
                refresh();
            });
        }
    }

    private fillBezirke(bundesland: string) {
        this.gemeinde = null;
        const g = this.refGemeinden._where((el) => el.bundesland === bundesland)._select((el) => el.bezirk)._distinct();
        this.bezirk = new DropDownComponent({
            clearable: true,
            defaultSelected: false, data: g.map((x) => ({ value: x, text: x })),
            onSelect: ((val) => { this.fillGemeinden(bundesland, val as string); })
        });
        JSLRender.lastCreatedRenderer.render();
    }

    private fillGemeinden(bundesland: string, bezirk: string) {
        const g = this.refGemeinden._where((el) => el.bundesland === bundesland && el.bezirk === bezirk)._select((el) => el.gemeinde)._distinct();
        this.gemeinde = new DropDownComponent({
            clearable: true,
            defaultSelected: false, data: g.map((x) => ({ value: x, text: x })),
            onSelect: ((val) => { refresh(); }) // necessary?
        });
        JSLRender.lastCreatedRenderer.render();
    }


}
